import { useState, useEffect } from 'react';
import { productService, Product, UpdatePriceRequest } from '../services/product/product.service';
import { message } from 'antd';

export const useProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await productService.getAllProducts();
      setProducts(data);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Ürünler yüklenirken hata oluştu';
      setError(errorMessage);
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const updateProductPrice = async (productId: number, priceData: UpdatePriceRequest) => {
    setLoading(true);
    try {
      const updatedProduct = await productService.updateProductPrice(productId, priceData);
      message.success('Ürün fiyatı başarıyla güncellendi');
      
      // Listeyi güncelle - eski ürünü pasif yap ve yeni ürünü ekle
      setProducts(prev => 
        prev.map(product => 
          product.id === productId && product.isActive 
            ? { ...product, isActive: false }
            : product
        ).concat(updatedProduct)
      );
      
      return updatedProduct;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Fiyat güncellenirken hata oluştu';
      setError(errorMessage);
      message.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return {
    products,
    loading,
    error,
    fetchProducts,
    updateProductPrice
  };
}; 